import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function Settings() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Settings</Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Partner settings coming soon. Manage your profile, notifications, and preferences.
        </Typography>
      </Paper>
    </Box>
  );
}
